import { Component, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface DialogData {
  id: number;
  name: string;
}

@Component({
  selector: 'app-advanced-filter-delete-dialog',
  templateUrl: './advanced-filter-delete-dialog.component.html',
  styleUrls: ['./advanced-filter-delete-dialog.component.scss'],
  standalone: false,
})
export class AdvancedFilterDeleteDialogComponent {
  onDeleteAdvancedFilter = new EventEmitter<number>();

  constructor(
    private dialogRef: MatDialogRef<AdvancedFilterDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  deleteAdvancedFilter(): void {
    this.onDeleteAdvancedFilter.emit(this.data.id);
    this.dialogRef.close();
  }
}
